









import { Component, Mixins } from "vue-property-decorator";
import mixins from "@/mixins";

@Component
class FoxONEAuth extends Mixins(mixins.publicPage) {
  needAuth = false;

  back = false;

  loading = true;

  get appbar() {
    return {
      show: false
    };
  }

  get title() {
    return this.$t("common.login") as string;
  }

  get code() {
    return this.$route.query.code as string;
  }

  get redirect() {
    const state = this.$route.query.state as string;
    try {
      const redirect = JSON.parse(decodeURIComponent(state));
      return redirect;
    } catch (error) {
      return "";
    }
  }

  async requestToken() {
    try {
      const foxToken = await this.$bridge.getToken();
      const {
        access_token: token
      } = await this.$api.account.getFusionTokenByFoxToken(foxToken);
      this.$store.commit("auth/SET_TOKEN", { token });
      this.handleRedirect();
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
      setTimeout(() => {
        this.handleRedirect();
      }, 2000);
    }
  }

  handleRedirect() {
    if (this.redirect) {
      document.location.replace(this.redirect);
    } else {
      this.$helper.toFusionPath(this, "basis", {
        name: "home"
      });
    }
  }

  mounted() {
    this.requestToken();
  }
}
export default FoxONEAuth;
